"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[SignalingClientSubscribe]] contains settings for the Subscribe SignalFrame.
 */

var SignalingClientSubscribe = /*#__PURE__*/_createClass(
/** Initializes a SignalingClientSubscribe with the given properties.
 *
 * @param attendeeId Attendee ID of the client
 * @param sdpOffer SDP offer created by WebRTC
 * @param audioHost host
 * @param audioMuted Whether audio from client is muted
 * @param audioCheckin Whether audio is in checked-in state
 * @param receiveStreamIds Which video streams to receive
 * @param localVideoEnabled Whether to send a video stream for the local camera
 * @param array of local video stream description
 * @param connectionTypeHasVideo Whether connection type has video
 */
function SignalingClientSubscribe(attendeeId, sdpOffer, audioHost, audioMuted, audioCheckin, receiveStreamIds, localVideoEnabled, videoStreamDescriptions, connectionTypeHasVideo) {
  _classCallCheck(this, SignalingClientSubscribe);

  this.attendeeId = attendeeId;
  this.sdpOffer = sdpOffer;
  this.audioHost = audioHost;
  this.audioMuted = audioMuted;
  this.audioCheckin = audioCheckin;
  this.receiveStreamIds = receiveStreamIds;
  this.localVideoEnabled = localVideoEnabled;
  this.videoStreamDescriptions = videoStreamDescriptions;
  this.connectionTypeHasVideo = connectionTypeHasVideo;
});

exports.default = SignalingClientSubscribe;